import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './dropdown.less'
import { domOnlyProps } from 'lib/form_utils'

class DropDown extends React.Component {
  /*
	 * label - The field's label, shown above the selected value
	 * formField - Redux form's field
	 * children - Custom options for the select component
	*/
  static propTypes = {
    label: PropTypes.string,
    formField: PropTypes.object,
    children: PropTypes.any,
  }

  render() {
    return (
      <div className="vx_floatingLabel">
        <label htmlFor="select">{this.props.label}</label>
        <div className="vx_select" data-label-content={this.props.label}>
          <select
            id="select"
            styleName="dropdown"
            className="form-control vx_form-control"
            {...domOnlyProps(this.props.formField)}
            value={this.props.formField.value}
          >
            {this.props.children}
          </select>
        </div>
      </div>
    )
  }
}

export default cssModules(DropDown, styles)
